/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerHatchery } from '../../models/customer-hatchery';

export interface SetActiveCustomer_1$Params {
  customerHatcheryId: number;
  isActive: boolean;
}

export function setActiveCustomer_1(http: HttpClient, rootUrl: string, params: SetActiveCustomer_1$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerHatchery>> {
  const rb = new RequestBuilder(rootUrl, setActiveCustomer_1.PATH, 'put');
  if (params) {
    rb.path('customerHatcheryId', params.customerHatcheryId, {});
    rb.path('isActive', params.isActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerHatchery>;
    })
  );
}

setActiveCustomer_1.PATH = '/api/customer/hatchery/{customerHatcheryId}/setActive={isActive}';
